import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";

const checkBoxStyles = theme => ({
  root: {
    color: "#000000",
    opacity: 0.7,
    "&$checked": {
      color: "#007FBD",
      opacity: 0.7
    }
  },
  checked: {}
});

const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);

export default function Checkboxes({
                                     label,
                                     checked,
                                     handleChange,
                                     disabled = false,
                                     ...rest}) {
  return (
    <>
      <FormControlLabel
        control={
          <CustomCheckbox
          checked={checked}
          onChange={handleChange}
          disabled={disabled}/>
        }
        label={label}
        {...rest}
      />
    </>
  );
}
